import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { AngularCsv } from "angular-csv-ext";
import { finalize } from "rxjs/operators";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { QuestionBase } from "../../../../shared/components/dynamic-form/question-base";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { BulkUploadInterface } from "../../../../shared/types/bulk-upload/bulk-upload.type";
import { PartnerService } from "../partner.service";
import { PartnerBulkUploadService } from "./partner-bulk-upload.service";
import { data } from "./partner-csv.json";

interface PartnerBulkUploadPayload {
  csv: File;
}

@Component({
  selector: "app-partner-bulk-upload",
  templateUrl: "./partner-bulk-upload.component.html",
  styleUrls: ["./partner-bulk-upload.component.css"],
  providers: [PartnerBulkUploadService],
})
export class PartnerBulkUploadComponent implements OnInit, BulkUploadInterface {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  questions: QuestionBase<string | boolean>[];
  loading = false;

  constructor(
    private questionsService: PartnerBulkUploadService,
    private partnerService: PartnerService,
    private notificationService: NotificationService,
    public location: Location,
  ) {}

  ngOnInit() {
    this.questionsService.generateQuestions().subscribe((qs) => {
      this.questions = qs;
    });
  }

  goBack() {
    this.location.back();
  }

  onSubmit(values: PartnerBulkUploadPayload) {
    this.loading = true;
    this.partnerService
      .getPutSignedUrl()
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (r) => {
          this.partnerService
            .uploadBatch(r.url, values.csv)
            .pipe(finalize(() => this.dynamicForm.enable()))
            .subscribe(
              () => {
                this.notificationService.success(
                  "New bulk upload scheduled from csv file. You will be notified by email once the file is processed.",
                );
                this.loading = false;
              },
              () => {
                this.notificationService.error("Something went wrong. Try again later");
                this.loading = false;
              },
            );
        },
        () => {
          this.notificationService.error("Something went wrong. Try again later");
          this.loading = false;
        },
      );
  }

  downloadCSV = (): void => {
    const options = {
      useHeader: false,
      headers: ["name", "type", "status"],
      nullToEmptyString: true,
      useBom: false,
    };
    new AngularCsv(data, "partner", options);
  };
}
